module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/premium/premium-single/premium-single.component.css
// module id = ./src/app/premium/premium-single/premium-single.component.css
// module chunks = main